import React from 'react';

import { Container } from '@mui/material';
import { observer } from 'mobx-react';

import { angularizeWithProviders } from '../../../shared/providers';
import { DetailedRevenue } from '../../containers/DetailedRevenue/DetailedRevenue';
import { loggedInUserDataStore } from '../../../shared/stores/loggedInUserDataStore';

const NgzDetailedRevenuePage = observer(() => {
  const { getEntityId, loggedInUser } = loggedInUserDataStore;

  const entityId = getEntityId();

  if (!loggedInUser) {
    return null;
  }

  return (
    <Container>
      <DetailedRevenue
        entityId={entityId}
        entityRegistrationDate={loggedInUser.registrationDate}
      />
    </Container>
  );
});

angularizeWithProviders(NgzDetailedRevenuePage, 'ngzDetailedRevenuePage', {});

export { NgzDetailedRevenuePage };
